<template>
  <div>
    <card title="Payment Details">
      <div class="row m-0">
        <div class="col-12 p-0">
          <div class="row m-0">
            <div class="col-12 mb-2 bold">Payment Methods</div>
            <div class="col-12">
              <checkbox v-for="(v, k) in paymentMethods" :key="k" :val="v" :value="v" v-model="payment.paymentMethods" name="paymentMethods" :id="'paymentMethods'+k">{{ v }}</checkbox>
            </div>
          </div>
        </div>
      </div>
    </card>
    <card title="Yoco" v-if="payment.paymentMethods.includes('Credit Card')">
      <text-input-inline title="Secret Key:" v-model="admin.yoco.secretKey"/>
      <text-input-inline title="Public Key:" v-model="payment.yoco.publicKey"/>
      <p class="mt-3">Sign up for a <a target="_blank" href="http://referral.yoco.com/ZQCpd">Yoco account: http://referral.yoco.com/ZQCpd</a> to accept credit / debit cards</p>
      <small>Once your account is created, browse to Sell Online->Payment Gateway and copy the keys from there</small>
    </card>
    <card title="EFT" v-if="payment.paymentMethods.includes('EFT')">
      <text-input title="EFT Details" v-model="payment.eft" :multiline="true"/>
    </card>
  </div>
</template>
<script>
export default {
  props: ['value', 'adminDetails'],
  components: {
    Checkbox: () => import('@/components/common/Checkbox.vue'),
    Card: () => import('@/components/common/Card.vue'),
    TextInput: () => import('@/components/common/TextInput.vue'),
    TextInputInline: () => import('@/components/common/TextInputInline.vue')
  },
  data () {
    return {
      paymentMethods: ['Cash on Delivery', 'Credit Card', 'EFT'],
      payment: {
        paymentMethods: [],
        yoco: {}
      },
      admin: {
        yoco: {}
      }
    }
  },
  watch: {
    admin () {
      this.$emit('update:adminDetails', this.admin)
    },
    payment: {
      handler () {
        this.$emit('input', this.payment)
      },
      deep: true
    }
  },
  mounted () {
    this.payment = Object.assign(this.payment, this.value)
    this.admin = Object.assign(this.admin, this.adminDetails)
  }
}
</script>
